// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"683c045e","564":"683c045e","3610":"683c045e","6293":"683c045e"}[chunkId] + ".chunk.css";
};